
  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.quantity-selector').forEach(selector => {
      console.log(selector);
      const decreaseBtn = selector.querySelector('.decrease');
      const increaseBtn = selector.querySelector('.increase');
      const quantityInput = selector.querySelector('#Quantity');
      
      decreaseBtn.addEventListener("click", () => {
        let value = parseInt(quantityInput.value);
        if (value > 1) {
          quantityInput.value = value - 1;
        }
      });

      increaseBtn.addEventListener("click", () => {
        let value = parseInt(quantityInput.value);
        quantityInput.value = value + 1;
      });
    });
  });